import { createStore } from 'vuex'

export default createStore({
  state: {
    isShowIndex: true
  },
  getters: {
    showIndexMethod(state) {
      return state.isShowIndex
    }
  },
  mutations: {
    showIndexMut(state, value) {
      state.isShowIndex = value
    }
  },
  actions: {
  },
  modules: {
  }
})
